let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b55kW")).then(() => parcelRequire('eQ2gb'));